module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightthunderstorm-4b88174b59d96da282da9affd7d51141.svg";